import { functions } from '../../../config/firebase'
import { getCallableErrorMessage } from '../../ProductsSyncMenu/syncDateUtils'
import { buildGiftFundItemForSave, GIFT_FUND_SOURCE_CUSTOM } from './giftFundHelpers'
import { mapGiftFundItemFromDoc } from './mapGiftFundItem'
import prepareGiftFundPhotosForSave from './prepareGiftFundPhotosForSave'

const saveGiftFundItem = async (draft) => {
  try {
    const payload = buildGiftFundItemForSave(draft)

    if (payload.sourceType === GIFT_FUND_SOURCE_CUSTOM) {
      payload.photos = await prepareGiftFundPhotosForSave(draft.photos || [], payload.id)
    }

    const callable = functions.httpsCallable('upsertGiftFundItem')
    const result = await callable(payload)
    const item = mapGiftFundItemFromDoc(result?.data?.item || result?.data)

    return {
      ok: true,
      item,
    }
  } catch (error) {
    console.error('[saveGiftFundItem] failed:', error)

    return {
      ok: false,
      message: getCallableErrorMessage(error),
    }
  }
}

export default saveGiftFundItem
